import { Component, OnDestroy } from '@angular/core';
import { Platform, ModalController, ToastController, ViewController, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import moment from 'moment';

@Component({
  selector: 'page-selectDate',
  templateUrl: 'selectdate.html'
})
export class SelectDatePage implements OnDestroy {
  private _onDestroy = new Subject();
  modeTakeAway = { how: '', when: '' };
  maxDate = '';
  minDate = '';
  days = [];
  slots = [];
  baseDate = null;
  load;
  takeHome = false;
  takeAway = false;
  slotsHome = [];
  slotsShop = [];

  constructor(
    public translateService: TranslateService, 
    public viewCtrl: ViewController, 
    public toastCtrl: ToastController, 
    public platform: Platform,
    public loadingCtrl: LoadingController,
    public storage: Storage, 
    public provider: provider, 
    public modalCtrl: ModalController, 
    public http: HttpClient, 
    public customizer: CustomizerProvider) {
    
    this.storage.get('modeTakeAwayOrDelivery').then((mode) => {
      if(mode == null)
        this.modeTakeAway.how = 'shop';
      else 
        this.modeTakeAway.how = mode;
    });

    this.getWorkingDays();

    this.provider.getDataInfo().subscribe(data => {
      this.load = JSON.parse((<any>data)._body).settings.ordersBySlot;
    })
  }

  getWorkingDays() {
    this.provider.getWorkingDays().subscribe(slots => {
      this.days = JSON.parse((<any>slots)._body);
      this.getSlots();
    }, err => {
      console.log(err);
    });
  }

  getSlots() {
    let loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });
    let date = this.baseDate;
    this.modeTakeAway.when = '';
    if(moment().isSame(this.baseDate, 'year') &&
      moment().isSame(this.baseDate, 'month') &&
      moment().isSame(this.baseDate, 'day')) {
      date = moment(date);
      date.set({h: moment().hour(), m: moment().minute(), s: moment().second()});
      date = date.format();
    }
    loading.present().then(() => {
      if(date && date !== null) {
        this.provider.getSlots(date, 'shop').takeUntil(this._onDestroy).subscribe(slots => {
          this.slots = JSON.parse((<any>slots)._body);
          this.slotsShop = this.slots;
          this.provider.getSlots(date, 'home').takeUntil(this._onDestroy).subscribe(slots => {
            this.slotsHome = JSON.parse((<any>slots)._body);
            if(this.slotsHome !== [])
              this.takeAway = true;
            loading.dismiss();
          }, err => {
            console.log(err);
            loading.dismiss();
          });
        }, err => {
          console.log(err);
          loading.dismiss();
        });
      } else {
        loading.dismiss();
      }
    })
  }

  setTakeAwayType() {
    this.modeTakeAway.when = '';
    if(this.takeHome) {
      this.modeTakeAway.how = 'home';
      this.slots = this.slotsHome;
    } else {
      this.modeTakeAway.how = 'shop';
    }
  }

  isSlotFree(slot) {
    if (this.load != 0) {
      let isFull = this.load - slot.load;

      if (isFull <= 0) {
        return true;
      } else {
        return false;
      }
    } else return false;
  }

  sendDate() {
    if(this.modeTakeAway.when == '') {
      return
    }

    this.viewCtrl.dismiss(this.modeTakeAway);
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  dismiss() {
    this.provider.clearApp();
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/selectdate/selectdate.ts